'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';

type Theme = 'light' | 'dark';

interface ThemeContextValue {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextValue>({
  theme: 'light',
  toggleTheme: () => {},
});

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = useState<Theme>('light');

  useEffect(() => {
    // Force light mode — dark mode is not fully supported yet
    setTheme('light');
    document.documentElement.classList.remove('dark');
    localStorage.removeItem('cfva-theme');
  }, []);

  const toggleTheme = () => {
    setTheme((prev) => {
      const next = prev === 'light' ? 'dark' : 'light';
      localStorage.setItem('cfva-theme', next);
      if (next === 'dark') {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
      return next;
    });
  };

  return <ThemeContext.Provider data-component-id="src/contexts/ThemeContext.tsx:40:9" data-component-path="src/contexts/ThemeContext.tsx" data-component-line="40" data-component-end-line="40" data-component-file="ThemeContext.tsx" data-component-name="ThemeContext.Provider" data-component-content="%7B%22elementName%22%3A%22ThemeContext.Provider%22%7D" value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
